import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { postChangePassword } from "../../helpers/fakebackend_helper";
import AuthField from "./AuthField";

const ChangePassword = () => {
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { currentPassword: "", newPassword: "", confirm: "" },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("Current password is required"),
      newPassword: Yup.string().min(8, "At least 8 characters").required("Required"),
      confirm: Yup.string().oneOf([Yup.ref("newPassword")], "Passwords do not match").required("Required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setError("");
      try {
        await postChangePassword(values.currentPassword, values.newPassword);
        setDone(true);
        resetForm();
      } catch (err) {
        setError(typeof err === "string" ? err : "Failed to change password.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  document.title = "Change Password | BiorGov Admin";

  return (
    <div style={{ padding: "1.5rem", display: "flex", justifyContent: "center" }}>
      <div style={{ maxWidth: 480, width: "100%" }}>
        <div className="bl-glass-strong" style={{ padding: "1.75rem" }}>
          <div style={{ marginBottom: "1.25rem" }}>
            <h2 style={{ margin: 0, fontFamily: "var(--bl-font-display)", fontSize: "1.4rem", fontWeight: 700, color: "#fff" }}>
              Change password
            </h2>
            <p style={{ marginTop: 6, marginBottom: 0, color: "var(--bl-text-soft)", fontSize: 14 }}>
              Other active sessions will be signed out.
            </p>
          </div>

          {done && <div className="alert alert-success" style={{ marginBottom: "1rem" }}>Password changed.</div>}
          {error && <div className="alert alert-danger" style={{ marginBottom: "1rem" }}>{error}</div>}

          <form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
            <AuthField
              label="Current password"
              name="currentPassword"
              type="password"
              autoComplete="current-password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.currentPassword}
              error={validation.errors.currentPassword}
              touched={validation.touched.currentPassword}
            />
            <AuthField
              label="New password"
              name="newPassword"
              type="password"
              autoComplete="new-password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.newPassword}
              error={validation.errors.newPassword}
              touched={validation.touched.newPassword}
            />
            <AuthField
              label="Confirm new password"
              name="confirm"
              type="password"
              autoComplete="new-password"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.confirm}
              error={validation.errors.confirm}
              touched={validation.touched.confirm}
            />
            <button type="submit" className="bl-btn-primary" style={{ width: "100%", padding: "0.7rem 1rem" }} disabled={validation.isSubmitting}>
              {validation.isSubmitting ? "Saving…" : "Change password"}
            </button>
          </form>

          <p style={{ textAlign: "center", marginTop: "1.25rem" }}>
            <Link to="/overview" style={{ color: "var(--bl-text-soft)", fontSize: 14 }}>Back to overview</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ChangePassword);
